module.exports = __webpack_public_path__ + "media/images/svg/logotype-95649090de52f13304d505a158f2270d.svg";